import { gamePath } from 'components/config/cloud';

export const getCertificate = (gameCode) =>
  `${gamePath(gameCode)}Certificates.zip`;

export const getCertificatePathByCountry = (gameCode, country) =>
  `${gamePath(gameCode)}Certificates/${country}.zip`;
